import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import Button from "../../../Button";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Popover,
  FormGroup,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import DownloadOptions from "./WidgetMenu/DownloadOptions";
import Loading from "../../../Notification-Loading/Loading/Loading";
import AlertContext from "../../../../context/AlertContext";
import constants from "../../../../constants";
import PaginationCustom from "./PaginationCustom";
import Select from "react-select";
import {
  isAfter,
  startOfWeek,
  subWeeks,
  startOfMonth,
  subMonths,
  format,
  isSameDay,
  isToday,
} from "date-fns";
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import { Columns3 } from "lucide-react";
import { TreeSelect } from "antd";
// import "antd/dist/reset.css";
import { getDataFromStorage } from "../../../../util";
import ApplyFilters from "../../../CommonComponents/ApplyFilters";
import Search from "../../../CommonComponents/Search";
import { useDebouncedValue } from "../../../../Hooks/useDebounceValue";
import InputDropdown from "../../../CommonComponents/InputDropdown";

import NameCell from "../../../CommonComponents/NameCell";
import { UserReportProvider } from "../../../../context/UserReportContext";

function sortLearningPathData(data) {
  return data
    .sort((a, b) => a.lpid - b.lpid)
    .map((learningPath) => ({
      ...learningPath,
      modules: learningPath.modules
        .sort((a, b) => a.morderno - b.morderno)
        .map((module) => ({
          ...module,
          mconfig: module.mconfig.sort((a, b) => a.orderno - b.orderno),
        })),
    }));
}

const Scores = (Props) => {
  const axios = useAxiosPrivate();
  const [page, setPage] = useState(1);
  const { downloadWidget, setDownloadWidet } = useContext(AlertContext);
  const [boardDescription, setBoardDescription] = useState(
    "Description for Scores"
  );
  const [showDownloadOptionsDropDown, setShowDownloadOptionsDropDown] =
    useState(false);
  const [widgetColumns, setWidgetColumns] = useState([]);
  const [testColumns, setTestColumns] = useState([]);
  const [widgetData, setWidgetData] = useState([]);
  const [totalDataCount, setDataTotalCount] = useState(0);
  const [orientation, setOrientation] = useState("landscape");
  const [orderby, setOrderby] = useState("ASC");
  const [sortby, setSortby] = useState("name");
  // const [render, setRender] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    college: null,
    branch: null,
    startDate: null,
    endDate: null,
    assignmentIds: [],
    search: "",
  });

  const Alert = useContext(AlertContext);

  const [dateRange, setDateRange] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [collegeList, setCollegeList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [college, setCollege] = useState({ label: "All", value: 0 });
  const defaultCollegeRef = useRef(null);
  const [branch, setBranch] = useState({ label: "All", value: 0 });
  const [testList, setTestList] = useState([]);
  const [assignmentIds, setAssignmentIds] = useState([]);
  const [value, setValue] = useState([]);
  const assignList = useRef([]);

  const limit = Props.batchDashboard ? 10 : 10;

  // New state for column visibility
  const [columnVisibility, setColumnVisibility] = useState({
    name: true,
    email: false,
    branch: false,
    college: false,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);

  const handleSettingClose = () => {
    setAnchorE2(null);
  };

  const handleApplyClose = () => {
    if (!startDate || !endDate) {
      Alert.setShowNotify({
        show: true,
        title: "Error",
        msg: "Please select both start and end dates.",
      });
    }
    setAnchorE2(null);
  };

  const handleCancelClose = () => {
    setStartDate(null);
    setEndDate(null);
    setAnchorE2(null);
  };

  // Add state for tracking filter changes and apply functionality
  const [filtersApplied, setFiltersApplied] = useState(true);
  const [filtersChanged, setFiltersChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // NEW: Search states
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebouncedValue(searchTerm, 500);
  // Toggle column visibility
  const handleToggleColumn = (column) => {
    if (column !== "name") {
      setColumnVisibility((prev) => ({
        ...prev,
        [column]: !prev[column],
      }));
    }
  };

  // Handle click on settings icon
  const handleSettingsClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle close of popover
  const handleSettingsClose = () => {
    setAnchorEl(null);
  };

  // Filter widgetColumns1 based on visibility settings
  const getVisibleColumns = () => {
    const columns = [];
    if (columnVisibility.name) columns.push("Name");
    if (columnVisibility.email) columns.push("Email address");
    if (columnVisibility.branch) columns.push("Branch");
    if (columnVisibility.college) columns.push("College");
    columns.push(...testColumns);
    return columns;
  };

  const handleResponse = (title, msg) => {
    Alert.setShowNotify({
      show: true,
      title: title,
      msg: msg,
    });
  };

  // console.log("searchInputRef.current", searchInputRef.current);

  useEffect(() => {
    if (!filtersChanged) return;
    // Reset pagination and trigger data fetch
    setPage(1);
    setFiltersApplied(true);
  }, [debouncedSearchTerm]);

  // Initialize dates based on batch dashboard
  useEffect(() => {
    if (Props.batchDashboard) {
      const batStartDate = Props.batchStartDate
        ? new Date(Props.batchStartDate)
        : new Date();
      const today = new Date();
      // const batStartDate = startOfWeek(today, { weekStartsOn: 1 });

      setStartDate(batStartDate);
      setEndDate(today);

      // Set default date range to "From Start"
      setDateRange({ value: "fromStart", label: "From Start" });
      setAppliedFilters({
        college: { label: "All", value: 0 },
        branch: null,
        startDate: batStartDate,
        endDate: today,
        assignmentIds: [],
        search: "",
      });
    }
  }, [Props.batchDashboard, Props.batchStartDate]);

  useEffect(() => {
    if (Props.batchDashboard) {
      try {
        const responseOfColleges = async () => {
          let response = await axios.get("node/admin/batch/college", {
            params: {
              id: Props.batchId,
              filter:true,
            },
            headers: { "Content-type": "application/json" },
          });
          // console.log("response>>>", response.data);
          const transformedData = response.data.data.map((item, index) => {
            return { label: item.name, value: index + 1 };
          });
          // console.log("transformedData****", transformedData);
          const allOption = { label: "All", value: 0 };
          setCollegeList([allOption, ...transformedData]);
          defaultCollegeRef.current = allOption;
          setCollege(allOption);

        };

        responseOfColleges();
      } catch (err) {
        if (err.message.includes("403")) {
          handleResponse(
            "Error",
            "You have been logged-out due to inactivity. Login again."
          );
          Alert.setIsUnAuth(true);
        } else {
          handleResponse("Error", err.message);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (Props.batchDashboard) {
      try {
        const responseOfBranches = async () => {
          let response = await axios.get("node/admin/batch/college/branch", {
            params: {
              id: Props.batchId,
              cname: college?.label,
            },
            headers: {
              "Content-type": "application/json",
            },
          });
          const transformedData = response?.data?.data?.map((item, index) => {
            return { label: item.branch, value: index + 1 };
          });
          const allOption = { label: "All", value: 0 };
          setBranchList([allOption, ...transformedData]);
          if (college?.value !== 0) setBranch(allOption);
        };

        responseOfBranches();
      } catch (err) {
        if (err.message.includes("403")) {
          handleResponse(
            "Error",
            "You have been logged-out due to inactivity. Login again."
          );
          Alert.setIsUnAuth(true);
        } else {
          handleResponse("Error", err.message);
        }
      }
    }
  }, [college]);

  const formatTreeData = (data) => {
    return data.map((lp) => ({
      title: lp.lpname,
      value: `lp-${lp.lpid}`,
      children: lp.modules.map((mod) => ({
        title: mod.mname,
        value: `mod-${mod.mid}`,
        children: mod.mconfig.map((cfg) => ({
          title: cfg.name,
          value: String(cfg.lpcid),
          isLeaf: true,
        })),
      })),
    }));
  };

  // Utility: flatten selected values into assignment IDs only
  const extractAssignments = (selected, tree = testList) => {
    let result = [];

    const traverse = (nodes, parentSelected = false) => {
      for (const node of nodes) {
        const isSelected = selected.includes(node.value) || parentSelected;

        if (node.isLeaf) {
          if (isSelected) {
            result.push(Number(node.value));
          }
        } else if (node.children) {
          traverse(node.children, isSelected); // 👈 pass parentSelected down
        }
      }
    };

    traverse(tree);
    return [...new Set(result)];
  };

  const handleChange = (newValue) => {
    setValue(newValue);
    const aIdsss = extractAssignments(newValue);
    setAssignmentIds(aIdsss);
  };

  // const assignmentParams = ()=> {
  //   let params = {};
  //   if (startDate && endDate) {
  //       params.sd = format(startDate, 'yyyy-MM-dd');
  //       params.ed = format(endDate, 'yyyy-MM-dd HH:mm:ss');
  //   }
  //   return params;
  // }

  useEffect(() => {
    // node/admin/batch/:id/assignments
    if (Props?.batchDashboard) {
      try {
        setTestList([]);
        const assignmentResponse = async () => {
          let response = await axios.get(
            `node/admin/batch/${Props.batchId}/assignments`,
            {
              // params: assignmentParams(),
              headers: {
                "Content-type": "application/json",
              },
            }
          );

          if (response?.data?.data.length > 0) {
            let data = JSON.parse(
              typeof response.data.data === "string" ? response.data.data : "[]"
            );
            const sortedData = sortLearningPathData(data);
            const transformedData = formatTreeData(sortedData);

            setTestList(transformedData);
            assignList.current = transformedData;
            setValue(transformedData.map((lp) => lp.value)); // Select all by default
          }
        };
        assignmentResponse();
      } catch (err) {
        if (err.message.includes("403")) {
          handleResponse(
            "Error",
            "You have been logged-out due to inactivity. Login again."
          );
          Alert.setIsUnAuth(true);
        } else {
          handleResponse("Error", err.message);
        }
      }
    }
  }, []);

  const handleInputChange = (value, name) => {
    if (name === "dateRange") {
      setDateRange(value);
      if (!value || value === null || value === undefined) {
        setStartDate(null);
        setEndDate(null);
      }

      if (value && value.value === "custom") {
        setAnchorE2(true);
      }

      // Handle predefined date ranges
      if (value && value.value !== "custom") {
        const today = new Date();
        const batStartDate = Props.batchStartDate
          ? new Date(Props.batchStartDate)
          : new Date();

        let newStartDate = batStartDate;
        let newEndDate = today;

        switch (value.value) {
          case "thisWeek":
            newStartDate = startOfWeek(today, { weekStartsOn: 1 });
            break;
          case "lastWeek":
            newStartDate = subWeeks(startOfWeek(today, { weekStartsOn: 1 }), 1);
            newEndDate = startOfWeek(today, { weekStartsOn: 1 });
            break;
          case "last2Weeks":
            newStartDate = subWeeks(startOfWeek(today, { weekStartsOn: 1 }), 2);
            break;
          case "thisMonth":
            newStartDate = startOfMonth(today);
            break;
          case "lastMonth":
            newStartDate = startOfMonth(subMonths(today, 1));
            newEndDate = startOfMonth(today);
            break;
          case "last3Months":
            newStartDate = startOfMonth(subMonths(today, 3));
            break;
          case "fromStart":
            newStartDate = batStartDate;
            break;
          default:
            break;
        }

        setStartDate(newStartDate);
        setEndDate(newEndDate);
      }
    } else if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else if (name === "college") {
      setCollege(value);
      if (value?.value !== 0 && (!branch)) {
        setBranch({ label: "All", value: 0 });
      }
    } else if (name === "branch") {
      setBranch(value);
    }

    // Mark filters as not applied when user makes changes
    setFiltersApplied(false);
  };

  // Apply filters handler
  const handleApplyFilters = () => {
    setPage(1); // Reset to first page when applying new filters
    if (college === null) setCollege({ label: "All", value: 0 });//to retain college filter after data fetch
    else if (college.value !== 0 && (!branch || branch.value === null)) setBranch({ label: "All", value: 0 });

    if (value.length === 0) setValue(assignList.current.map((lp) => lp.value));//to retain assignment filter after data fetch
    setFiltersApplied(true);
    setAppliedFilters({
      college,
      branch,
      startDate,
      endDate,
      assignmentIds,
      search: debouncedSearchTerm?.trim(),
    });
  };

  // Reset filters handler
  const handleResetFilters = () => {
    if (Props.batchDashboard) {
      const today = new Date();
      const batStartDate = Props.batchStartDate
        ? new Date(Props.batchStartDate)
        : new Date();

      setDateRange({ value: "fromStart", label: "From Start" });
      // setDateRange(null);
      setStartDate(batStartDate);
      setEndDate(today);

      if (collegeList.length > 2) setCollege({ label: "All", value: 0 });
      if (branchList.length > 2) setBranch({ label: "All", value: 0 });
      // setCollege(defaultCollegeRef.current || { label: "All", value: 0 });
      // setBranch({ label: "All", value: 0 });
      setValue(assignList.current.map((lp) => lp.value)); // Select all by default

      // Apply the reset filters
      setPage(1);
      setSearchTerm(""); // Reset search too
      setFiltersApplied(true);
      setWidgetData([]);
      setFiltersChanged(false);
      setAppliedFilters({
        college: { label: "All", value: 0 },
        branch: null,
        startDate: batStartDate,
        endDate: today,
        assignmentIds: [],
        search: "",
      });
    }
  };

  // Generate date ranges based on batch start date
  const getDateRanges = () => {
    if (!Props.batchStartDate) return [];

    const batStartDate = new Date(Props.batchStartDate);
    const today = new Date();
    const ranges = [];

    // This Week
    const thisWeekStart = startOfWeek(today, { weekStartsOn: 1 });
    if (
      isAfter(thisWeekStart, batStartDate) ||
      thisWeekStart.getTime() === batStartDate.getTime()
    ) {
      ranges.push({ value: "thisWeek", label: "This Week" });
    }

    // Last Week
    const lastWeekStart = subWeeks(startOfWeek(today, { weekStartsOn: 1 }), 1);
    if (isAfter(lastWeekStart, batStartDate)) {
      ranges.push({ value: "lastWeek", label: "Last Week" });
    }

    // Last 2 Weeks
    const last2WeeksStart = subWeeks(
      startOfWeek(today, { weekStartsOn: 1 }),
      2
    );
    if (isAfter(last2WeeksStart, batStartDate)) {
      ranges.push({ value: "last2Weeks", label: "Last 2 Weeks" });
    }

    // This Month
    const thisMonthStart = startOfMonth(today);
    if (
      isAfter(thisMonthStart, batStartDate) ||
      thisMonthStart.getTime() === batStartDate.getTime()
    ) {
      ranges.push({ value: "thisMonth", label: "This Month" });
    }

    // Last Month
    const lastMonthStart = startOfMonth(subMonths(today, 1));
    if (isAfter(lastMonthStart, batStartDate)) {
      ranges.push({ value: "lastMonth", label: "Last Month" });
    }

    // Last 3 Months
    const last3MonthsStart = startOfMonth(subMonths(today, 3));
    if (isAfter(last3MonthsStart, batStartDate)) {
      ranges.push({ value: "last3Months", label: "Last 3 Months" });
    }

    // From Start
    ranges.push({ value: "fromStart", label: "From Start" });

    // Custom (always allow)
    ranges.push({ value: "custom", label: "Custom" });

    return ranges;
  };

  const dateRanges = getDateRanges();

  const getStyles = makeStyles({
    stickyCellname1: {
      maxWidth: "150px",
      minWidth: "150px",
      boxShadow: "5px 2px 5px grey",
      position: "sticky",
      left: 0,
      background: "#f9fafb",
      textOverflow: "ellipsis",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      overflow: "hidden",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
    stickyCellemail1: {
      boxShadow: "5px 2px 5px grey",
      position: "sticky",
      left: `${getVisibleColumns().includes("Name") ? "150px" : "0px"} `,
      maxWidth: "150px",
      minWidth: "150px",
      background: "#f9fafb",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
    stickyCellbranch1: {
      boxShadow: "5px 2px 5px grey",
      position: "sticky",
      left: `${getVisibleColumns().includes("Email address")
          ? getVisibleColumns().includes("Branch")
            ? "300px"
            : "150px"
          : "150px"
        } `,
      maxWidth: "150px",
      minWidth: "150px",
      background: "#f9fafb",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
    stickyCellcollege1: {
      boxShadow: "5px 2px 5px grey",
      position: "sticky",
      left: `${getVisibleColumns().includes("Email address")
          ? getVisibleColumns().includes("Branch")
            ? getVisibleColumns().includes("College")
              ? "450px"
              : "300px"
            : "300px"
          : getVisibleColumns().includes("Branch")
            ? getVisibleColumns().includes("College")
              ? "300px"
              : "150px"
            : "150px"
        } `,
      maxWidth: "150px",
      minWidth: "150px",
      background: "#f9fafb",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
    stickyCellname: {
      maxWidth: "150px",
      minWidth: "150px",
      boxShadow: "5px 2px 5px grey",
      position: "sticky",
      left: 0,
      background: "#ffffff",
      textOverflow: "ellipsis",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      overflow: "hidden",
      whiteSpace: "nowrap",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#101828",
      padding: "9px",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
    },

    stickyCellemail: {
      boxShadow: "5px 2px 5px grey",
      position: "sticky",
      left: `${getVisibleColumns().includes("Name") ? "150px" : "0px"} `,
      maxWidth: "150px",
      minWidth: "150px",
      background: "#ffffff",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
    },
    stickyCellbranch: {
      boxShadow: "5px 2px 5px grey",
      position: "sticky",
      left: `${getVisibleColumns().includes("Email address")
          ? getVisibleColumns().includes("Name")
            ? "300px"
            : "150px"
          : "150px"
        } `,
      maxWidth: "150px",
      minWidth: "150px",
      background: "#ffffff",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
    },
    stickyCellcollege: {
      boxShadow: "5px 2px 5px grey",
      position: "sticky",
      left: `${getVisibleColumns().includes("Email address")
          ? getVisibleColumns().includes("Branch")
            ? getVisibleColumns().includes("College")
              ? "450px"
              : "300px"
            : "300px"
          : getVisibleColumns().includes("Branch")
            ? getVisibleColumns().includes("College")
              ? "300px"
              : "150px"
            : "150px"
        } `,
      maxWidth: "150px",
      minWidth: "150px",
      background: "#ffffff",
      textOverflow: "ellipsis",
      overflow: "hidden",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
    },
    na1: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      maxWidth: "150px",
      minWidth: "150px",
      textWrap: "nowrap",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: "#344054",
      padding: "9px",
      boxShadow:
        "inset -1px 0 0 0 rgb(224, 224, 224),inset 0 1px 0 0 rgb(224, 224, 224)",
    },
    na: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      maxWidth: "150px",
      minWidth: "150px",
      textWrap: "nowrap",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: "#667085",
      padding: "9px !important",
      boxShadow: "inset -1px 0px 0px 0 rgb(224, 224, 224)",
    },
  });
  const classes = getStyles();
  const getCol = (col) => {
    if (col == "Name") {
      return "name";
    } else if (col == "Email address") {
      return "email";
    } else if (col == "Branch") {
      return "branch";
    } else if (col == "College") {
      return "college";
    } else if (col == "Completed") {
      return "completedCount";
    } else if (col == "Pending") {
      return "pendingCount";
    } else if (col == "Overdue") {
      return "dueDateCount";
    } else if (col == "Selected range") {
      return "percentage_selected_duration";
    } else if (col == "From Start") {
      return "percentage_total_duration";
    } else return col;
  };

  const getColForHeaders = (col) => {
    if (
      col == "Name" ||
      col == "Email address" ||
      col == "Branch" ||
      col == "College"
    ) {
      return col;
    } else {
      let lastUnderscoreIndex = col.lastIndexOf("_");
      return col.substring(0, lastUnderscoreIndex);
    }
  };

  const sortByColumn = (col) => {
    if (col == "Name" || col == "Branch" || col == "College") {
      let orderBy = "ASC";
      if (getCol(col) == sortby) {
        orderBy = orderby == "ASC" ? "DESC" : "ASC";
      }
      col == "Name"
        ? setSortby("name")
        : col == "Branch"
          ? setSortby("branch")
          : setSortby("college");

      setOrderby(orderBy);
    }
  };

  const buildParams = (searchValue = "") => {
    let params = {
      type: Props.data.type,
      offset: page,
      sortby,
      orderby,
    };

    if (Props.batchDashboard) {
      params.batchId = Props.batchId; // Use actual batchId from props

      // Add date filters if dates are selected
      if (startDate && endDate) {
        params.startDate = format(startDate, "yyyy-MM-dd");
        params.endDate = format(endDate, "yyyy-MM-dd HH:mm:ss");
      }

      if (!params.startDate) {
        setDateRange({ value: "fromStart", label: "From Start" });
        params.startDate = Props.batchStartDate;
        params.endDate = format(new Date(), "yyyy-MM-dd HH:mm:ss");
      }

      // Add other filters
      if (college && college?.value !== 0) params.college = college?.label;
      if (branch && branch?.value !== 0) params.branch = branch?.label;

      if (limit) params.limit = limit;

      // FIX: Proper array handling for assignmentIds
      if (assignmentIds && assignmentIds.length > 0) {
        // For consistent behavior across environments
        params.assignmentIds = JSON.stringify(assignmentIds);
      }
      // ADD search parameter
      if (searchValue && searchValue.trim()) {
        params.search = searchValue.trim();
      }
    }

    return params;
  };

  // let params = Props.batchDashboard ?{
  //             type: Props.data.type,
  //             offset: page,
  //             sortby,
  //             orderby,
  //             batchId : Props.batchId,
  //             batStartDate: Props.batchStartDate,
  //             startDate: startDate ,
  //             endDate: endDate,
  //             college: college?.label,
  //             branch: branch?.label,
  //             assignmentIds: assignmentIds,
  //           }: {
  //             type: Props.data.type,
  //             offset: page,
  //             sortby,
  //             orderby,
  //           }
  // Reset page to 1 when filters change - NEW FUNCTION
  // const resetPageOnFilterChange = () => {
  //   setPage(1);
  // };

  // Effect to reset page when filters change
  // useEffect(() => {
  //   resetPageOnFilterChange();
  // }, [startDate, endDate, college, branch, assignmentIds]);

  // UPDATED: Main data fetching useEffect
  useEffect(() => {
    if (!filtersApplied && Props.batchDashboard) return;

    fetchWidgetData(debouncedSearchTerm);
  }, [
    page,
    Props.data.wid,
    Props.refresh,
    sortby,
    orderby,
    filtersApplied,
    debouncedSearchTerm,
  ]);

  const fetchWidgetData = async (searchValue = "") => {
    setIsLoading(true);
    const params = buildParams(searchValue);
    try {
      let response = await axios.get(
        !Props.batchDashboard
          ? `node/admin/dashboard/${Props.dashboardId}/widget/${Props.data.wid}/report`
          : `node/admin/batch/dashboard/report`,
        { params: params }
      );

      if (response?.data?.data != undefined) {
        setWidgetData(response?.data?.data?.data);
        setDataTotalCount(response?.data?.data?.learnersTotalCount);
        let typeOfOrientation =
          response?.data?.data?.orientation == constants.ORIENTATION.LANDSCAPE
            ? "landscape"
            : "portrait";
        setOrientation(typeOfOrientation);
        updateColumns(
          response?.data?.data?.data[0],
          response?.data?.data?.headers
        );
      }
    } catch (error) {
      console.error("Error:", error);
      Alert.setShowNotify({
        show: true,
        title: "Error",
        msg: error.message,
      });
    } finally {
      setIsLoading(false);
      setFiltersApplied(false);
      setFiltersChanged(true);
      Props.setRefresh(false);
    }
  };

  const updateColumns = (columnfromResponse, testNames) => {
    const columns = [];
    const testColumns = [];
    if (columnfromResponse?.hasOwnProperty("name")) {
      columns.push("Name");
    }
    if (columnfromResponse?.hasOwnProperty("email")) {
      columns.push("Email address");
    }
    if (columnfromResponse?.hasOwnProperty("branch")) {
      columns.push("Branch");
    }
    if (columnfromResponse?.hasOwnProperty("college")) {
      columns.push("College");
    }

    for (let i = 0; i < testNames.length; i++) {
      columns.push(testNames[i]);
      testColumns.push(testNames[i]);
    }

    setWidgetColumns(columns);
    setTestColumns(testColumns);
  };

  const handleNext = () => {
    let totalPageCount = Math.ceil(totalDataCount / limit);
    setPage((prev) => Math.min(prev + 1, totalPageCount));
    setFiltersApplied(true);
  };

  const handlePrevious = () => {
    setPage((prev) => Math.max(prev - 1, 1));
    setFiltersApplied(true);
  };

  const columnsToShow = Props.batchDashboard
    ? getVisibleColumns()
    : widgetColumns;

  if ((college?.value === 0 || !college) && branch) {
    setBranch(null);
  }

  // console.log("------>:", getVisibleColumns().includes("Email address"));

  return (
    <div className="scoresContainer">
      <div className="boardHeader">
        <div className="leaderBoardwidgetNamendDescription">
          {/* <div>
            <text id="leaderboardText1"> {Props.data.name}</text>
            {boardDescription && (
              <text id="leaderboardText2"> {Props.data.description}</text>
            )}
          </div> */}
          {/* ADDED: Search Bar at the top */}
          <div
            className="searchContainer"
            style={{ width: "100%", maxWidth: "180px" }}
          >
            <Search
              placeholder="Search Student"
              value={searchTerm}
              width={"200px"}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                // setPage(1);
              }}
              iconPosition="end"
            />
          </div>
          {Props.batchDashboard && (
            <div className="leaderBoardFilters">
              {/* <div className="dateRange">
                <div className="attendanceFormSelect">
                  <Select
                    isClearable
                    options={dateRanges}
                    placeholder={"Date"}
                    value={dateRange}
                    onChange={(e) => {
                      handleInputChange(e, "dateRange");
                    }}
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "150px", 
                      }),
                      menu: (base) => ({
                        ...base,
                        width: "150px",
                      }),
                    }}
                  />
                </div>

                <Popover
                  open={Boolean(anchorE2)}
                  anchorEl={anchorE2}
                  onClose={handleSettingClose}
                  anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'center',
                    horizontal: 'center',
                  }}
                >
                   <div style={{padding: "16px 16px 0px 16px"}}><strong>Selected Dates:</strong></div>
                    
                    <div className="startandenddatePicker">
                      
                     
                      <Form.Group className="mb-3">
                        <Form.Label id="batchStartDateLabel">
                          <strong>Start Date:</strong> {startDate ? startDate.toLocaleDateString() : 'Not selected'}
                        </Form.Label>
                        <DatePicker
                            name="startDate"
                            selected={startDate}
                            onChange={(date) => handleInputChange(date, "startDate")}
                            autoComplete="off"
                            minDate={Props.batchDashboard ? new Date(Props.batchStartDate) : new Date()}
                            maxDate={new Date()}
                            dateFormat="dd/MM/yyyy"
                            className="batchStartDate"
                            placeholderText="Start Date..."
                            inline 
                          /> 
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label id="batchStartDateLabel">
                          <strong>End Date:</strong> {endDate ? endDate.toLocaleDateString() : 'Not selected'}
                        </Form.Label>
                        <DatePicker
                          name="endDate"
                          selected={endDate} 
                          onChange={(date) => handleInputChange(date, "endDate")}
                          autoComplete="off"
                          minDate={startDate || (Props.batchDashboard ? new Date(Props.batchStartDate) : new Date())}
                          maxDate={new Date()}
                          dateFormat="dd/MM/yyyy"
                          className="batchStartDate"
                          placeholderText="End Date..."
                          inline 
                        />
                      </Form.Group>

                     
                    </div>
                     
                    <div className="datePickerActions" style={{ 
                      display: 'flex', 
                      justifyContent: 'flex-end', 
                      gap: '12px', 
                      padding: '0 16px 12px 16px'
                    }}>
                      
                      <Button
                        size={"sm"}
                        onClick={handleCancelClose}
                        hierarchy={{
                          type: "secondaryGrey",
                          buttonText: "Cancel",
                        }}
                      />
                       <Button
                        size={"sm"}
                        disable={ (dateRange && dateRange.value === "custom" && (!startDate || !endDate))}
                        hierarchy={{
                          type: "primary",
                          buttonText: "Apply",
                        }}
                        onClick={handleApplyClose}
                      />
                    </div>
                </Popover> 
              </div> */}

              <TreeSelect
                style={{ width: 150 }}
                value={value}
                popupMatchSelectWidth={false} // ✅ replaces dropdownStyle width
                listHeight={400} // ✅ replaces dropdownStyle height
                treeData={testList}
                placeholder="Assignments"
                treeCheckable={true}
                showCheckedStrategy={TreeSelect.SHOW_PARENT}
                onChange={handleChange}
                maxTagCount="responsive"
              />

              {getDataFromStorage("role") !== constants.Roles.hr &&
                (
                  <div className="collegeList">
                    <InputDropdown
                      options={collegeList}
                      placeholder="College"
                      value={college?.value ?? ""}
                      disabled={
                        !collegeList?.length
                      }
                      onChange={(selectedValue) => {
                        const selectedOption = collegeList.find(
                          (item) => item.value === selectedValue
                        );

                        handleInputChange(selectedOption, "college");
                      }}
                      className="college-dropdown"
                    />
                  </div>
                )}

              <div className="branchList">
                <InputDropdown
                  options={branchList}
                  placeholder="Branch"
                  value={branch?.value ?? ""}
                  disabled={
                    !college ||
                    !branchList ||
                    branchList?.length === 0 ||
                    college?.value === 0
                  }
                  onChange={(selectedValue) => {
                    const selectedOption = branchList.find(
                      (item) => item.value === selectedValue
                    );

                    handleInputChange(selectedOption, "branch");
                  }}
                  className="branch-dropdown"
                />
              </div>
              {/* Add Apply Filter and Reset Buttons */}
              <div
                className="filter-buttons"
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <Button
                  size={"sm"}
                  disable={isLoading}
                  hierarchy={{
                    type: "primary",
                    buttonText: isLoading ? "Applying..." : "Apply Filters",
                  }}
                  onClick={handleApplyFilters}
                />

                <Button
                  size={"sm"}
                  disable={isLoading}
                  onClick={handleResetFilters}
                  hierarchy={{
                    type: "secondaryGrey",
                    buttonText: "Reset",
                  }}
                />

                {/* {!filtersApplied && (
                 <span style={{ 
                   color: '#ff9800', 
                   fontSize: '12px', 
                   marginLeft: '8px',
                   fontStyle: 'italic'
                 }}>
                   Filters not applied
                 </span>
               )} */}
              </div>

              <>
                <IconButton
                  onClick={handleSettingsClick}
                  size="small"
                  sx={{ ml: 0 }}
                  aria-label="column settings"
                >
                  <Tooltip title="Hide/Show Columns">
                    <Columns3 />
                  </Tooltip>
                </IconButton>

                <Popover
                  open={Boolean(anchorEl)}
                  anchorEl={anchorEl}
                  onClose={handleSettingsClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <div style={{ padding: "16px" }}>
                    <h5 style={{ margin: "0 0 12px 0" }}>Display Columns</h5>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={columnVisibility.name}
                            onChange={() => handleToggleColumn("name")}
                          />
                        }
                        label="Name"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={columnVisibility.email}
                            onChange={() => handleToggleColumn("email")}
                          />
                        }
                        label="Email"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={columnVisibility.branch}
                            onChange={() => handleToggleColumn("branch")}
                          />
                        }
                        label="Branch"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={columnVisibility.college}
                            onChange={() => handleToggleColumn("college")}
                          />
                        }
                        label="College"
                      />
                    </FormGroup>
                  </div>
                </Popover>
              </>
            </div>
          )}
        </div>
        {downloadWidget == Props.data.wid && !Props.batchDashboard && (
          <span className="downloadSingleWidgetAlert">
            Download in Progress,Please Wait...
          </span>
        )}
        <div className="downloadDropdown">
          {showDownloadOptionsDropDown && (
            <div
              onMouseLeave={() => {
                setShowDownloadOptionsDropDown(false);
              }}
            >
              <DownloadOptions
                name={Props?.data?.name}
                type={Props.data.type}
                dashboardId={Props.dashboardId}
                widgetId={Props.data.wid}
                orientation={orientation}
                batchDashboard={Props.batchDashboard}
                batchId={Props.batchId}
                batchStartDate={Props.batchStartDate}
                // startDate={Props.data.type === constants.BOARD_WIDGETS.ATTENDANCE ? appliedFilters.startDate : null}
                // endDate={Props.data.type === constants.BOARD_WIDGETS.ATTENDANCE ? appliedFilters.endDate : null}
                college={
                  appliedFilters.college?.value !== 0
                    ? appliedFilters.college?.label
                    : null
                }
                branch={
                  appliedFilters.branch?.value !== 0
                    ? appliedFilters.branch?.label
                    : null
                }
                assignmentIds={
                  appliedFilters.assignmentIds.length > 0
                    ? JSON.stringify(appliedFilters.assignmentIds)
                    : null
                }
                search={debouncedSearchTerm?.trim()}
              />{" "}
            </div>
          )}
          <span
            style={{ cursor: "pointer" }}
            onClick={() => setShowDownloadOptionsDropDown(true)}
            className="boarddownloadicon"
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.6577 12.5V15.8333C17.6577 16.2754 17.4821 16.6993 17.1696 17.0118C16.857 17.3244 16.4331 17.5 15.991 17.5H4.32438C3.88235 17.5 3.45843 17.3244 3.14587 17.0118C2.83331 16.6993 2.65771 16.2754 2.65771 15.8333V12.5M5.99105 8.33333L10.1577 12.5M10.1577 12.5L14.3244 8.33333M10.1577 12.5V2.5"
                stroke="#344054"
                stroke-width="1.67"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <svg
              width="7"
              height="6"
              viewBox="0 0 7 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.78205 0.799874L4.04042 5.53542C3.8889 5.79714 3.81313 5.928 3.71429 5.97195C3.62807 6.01029 3.52964 6.01029 3.44342 5.97195C3.34458 5.928 3.26882 5.79714 3.1173 5.53542L0.375669 0.799876C0.2236 0.537211 0.147566 0.40588 0.158804 0.298091C0.168606 0.204075 0.217862 0.118642 0.294315 0.0630541C0.381968 -0.000677109 0.533722 -0.000677109 0.837229 -0.000677109L6.32049 -0.000677109C6.62399 -0.000677109 6.77575 -0.000677109 6.8634 0.0630541C6.93985 0.118642 6.98911 0.204075 6.99891 0.298091C7.01015 0.40588 6.93412 0.537211 6.78205 0.799874Z"
                fill="#667085"
              />
            </svg>
          </span>
        </div>
      </div>
      {isLoading && <Loading overlay />}
      {!isLoading && widgetData.length > 0 ? (
        <div className="tableContainer">
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead style={{ background: "#f9fafb" }}>
                <TableRow>
                  {/* {columnsToShow.map((column, ind) => (
                    <TableCell
                      key={ind}
                      title={getColForHeaders(column)}
                      className={
                        column == "Name"
                          ? classes.stickyCellname1
                          : column == "Email address"
                            ? classes.stickyCellemail1
                            : column == "Branch"
                              ? classes.stickyCellbranch1
                              : column == "College"
                                ? classes.stickyCellcollege1
                                : classes.na1
                      }
                      onClick={() => {
                        sortByColumn(column);
                      }}
                      align={
                        column == "Name" ||
                          column == "Branch" ||
                          column == "College" ||
                          column == "Email address"
                          ? "left"
                          : "center"
                      }
                    >
                      {getColForHeaders(column)}
                    </TableCell>
                  ))} */}

                  {columnsToShow.map((column, ind) => (
                    <TableCell
                      key={ind}
                      title={getColForHeaders(column)}
                      className={
                        column === "Name"
                          ? classes.stickyCellname1
                          : column === "Email address"
                            ? classes.stickyCellemail1
                            : column === "Branch"
                              ? classes.stickyCellbranch1
                              : column === "College"
                                ? classes.stickyCellcollege1
                                : classes.na1
                      }
                      onClick={() => {
                        sortByColumn(column);
                      }}
                      align={
                        ["Name", "Branch", "College", "Email address"].includes(column)
                          ? "left"
                          : "center"
                      }
                    >
                      {getColForHeaders(column)}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {widgetData.map((row, rowIndex) => (
                  <TableRow key={row.id}>
                    {/* {columnsToShow.map((column, colIndex) => (
                      <TableCell
                        title={
                          typeof row[column] === "object"
                            ? row[column].mark
                            : row[getCol(column)]
                        }
                        className={
                          column == "Name"
                            ? classes.stickyCellname
                            : column == "Email address"
                              ? classes.stickyCellemail
                              : column == "Branch"
                                ? classes.stickyCellbranch
                                : column == "College"
                                  ? classes.stickyCellcollege
                                  : classes.na
                        }
                        align={
                          column == "Name" ||
                            column == "Branch" ||
                            column == "College" ||
                            column == "Email address"
                            ? "left"
                            : "center"
                        }
                        key={colIndex}
                      >
                        {typeof row[column] === "object"
                          ? row[column].mark
                          : row[getCol(column)]}
                      </TableCell>
                    ))} */}
                    {columnsToShow.map((column, colIndex) => {
                      if (column === "Name") {
                        return (
                          <UserReportProvider key={colIndex}>
                            <NameCell
                              row={{
                                ...row,
                                Name: row.name,
                                learnerid: row.id,
                              }}
                              rowIndex={rowIndex}
                              className={classes.stickyCellname}
                              pos="batch-report-page-container"
                            />
                          </UserReportProvider>
                        );
                      }

                      return (
                        <TableCell
                          key={colIndex}
                          title={
                            typeof row[column] === "object"
                              ? row[column].mark
                              : row[getCol(column)]
                          }
                          className={
                            column === "Email address"
                              ? classes.stickyCellemail
                              : column === "Branch"
                                ? classes.stickyCellbranch
                                : column === "College"
                                  ? classes.stickyCellcollege
                                  : classes.na
                          }
                          align={
                            ["Branch", "College", "Email address"].includes(column)
                              ? "left"
                              : "center"
                          }
                        >
                          {typeof row[column] === "object"
                            ? row[column].mark
                            : row[getCol(column)]}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        <TableRow
          align="center"
          style={{
            height: "450px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {!filtersApplied && !filtersChanged ? (
            <ApplyFilters
              type={Props.data.type}
              text={`Choose ${Props.data.type !== 1 ? " Assignment(s)" : ""
                } from the filters above and hit Apply to load the ${Props.data.name
                } Report.`}
            />
          ) : (
            filtersChanged && (
              <ApplyFilters text="No data available for the selected filters. Try changing the filter options or click Reset." />
            )
          )}
        </TableRow>
      )}

      <div className="boardFooter">
        {!isLoading && widgetData.length > 0 && (
          <PaginationCustom
            totalPages={Math.ceil(totalDataCount / limit)}
            currentPage={page}
            setCurrentPage={setPage}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            setFiltersApplied={setFiltersApplied}
            batchDashboard={Props.batchDashboard}
          />
        )}
      </div>
    </div>
  );
};

export default Scores;
